module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter TableOfContents"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137509-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xiii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xiii"
    }
  }, [_c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_137509-00001"
    }
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("TABLE OF CONTENTS")])])]), _c('div', {
    staticClass: "block toc",
    attrs: {
      "id": "rw-block-toc_137509-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xiii"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_xiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847675026_chapter_01#pb-rw_1"
    }
  }, [_vm._v("The Star")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847675026_chapter_02#pb-rw_4"
    }
  }, [_vm._v("The Spread Of Ian Nicol")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847675026_chapter_03#pb-rw_8"
    }
  }, [_vm._v("The Problem")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847675026_chapter_04#pb-rw_11"
    }
  }, [_vm._v("The Cause Of Some Recent Changes")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847675026_chapter_05#pb-rw_17"
    }
  }, [_vm._v("The Comedy Of The White Dog")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_chapter_06#pb-rw_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crank That Made The Revolution")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_chapter_07#pb-rw_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great Bear Cult")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_chapter_08#pb-rw_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Start Of The Axletree")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_chapter_09#pb-rw_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five Letters From An Eastern Empire")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_chapter_10#pb-rw_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sir Thomas’s Logopandocy")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_chapter_11#pb-rw_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M. Pollard’s Prometheus")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_chapter_12#pb-rw_229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End Of The Axletree")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_chapter_13#pb-rw_268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Unique Case")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_chapter_14#pb-rw_271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inches In A Column")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_chapter_15#pb-rw_274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Likely Story Outside A Domestic Setting")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_chapter_16#pb-rw_275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Likely Story Within A Domestic Setting")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_acknowledgements#pb-rw_277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Acknowledgements")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675026_chapter_17#pb-rw_278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript by Author and Douglas Gifford")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137509-00003"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xiv"
    }
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br')])]), _c('a', {
    attrs: {
      "id": "pb-rw_xiv"
    }
  }, [_c('div', {
    staticClass: "media image align-center width-auto",
    attrs: {
      "id": "rw-media-image_137509-00001"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "xii-1.png"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "pb-rw_xiv"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xiv"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9612d384","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675026_tableofcontents.vue
// module id = 78
// module chunks = 0